<template>
  <div class="career-panorama">
     <div class="banner-head">
        <div class="banner-head-txt">
             <div class="title">职业全景导航系统</div>
             <div style="height: 26px;"></div>
             <div class="txt">AI驱动的一站式职业成长解决方案</div> 
        </div>
     </div>
     <div class="career-panorama-content">
         <img src="../../assets/specialist/bg.png" class="bg"/>
         <div class="content">
            <div class="content-box">
                <!--测评工具--->
                <div class="evaluation-tool" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-offset="-100">
                     <div class="evaluation-tool-box">
                        <div class="tool-txt">
                            <div style="height: 60px;"></div>
                            <div class="title">权威测评工具</div>
                            <div style="height: 10px;"></div>
                            <div class="txt">整合霍兰德职业兴趣测评、卡特尔 16 种人格因素测评、彩虹职业光谱测评、明尼苏达多顶人格问卷（MMPI）、MBTI职业性格测试 、艾森克人格测验(EPQ)等六种权威测评工具，涵盖职业兴趣、人格特质、心理健康等多维度评估，为学生提供全面深入的自我认知途径。</div>
                            <div style="height: 10px;"></div>
                            <div class="tags">
                                <div class="tag">多维交叉分析</div>
                                <div class="tag">职业兴趣图谱</div>
                                <div class="tag">心理健康评估</div>
                            </div>
                            <div style="height: 35px;"></div>
    
                            <div class="more-btn-no" @mouseenter="isAuthority = true" v-show="!isAuthority">
                                <div class="btn-txt">立即体验</div>
                                <div style="width: 8px;"></div>
                                <img src="../../assets/right.png" class="btn-img" style="width: 14px; height: 12px;"/>
                            </div>
                            <div class="more-btn" @click="openPopUp" @mouseleave="isAuthority = false" v-show="isAuthority">
                                <div class="btn-txt">立即体验</div>
                                <div style="width: 8px;"></div>
                                <img src="../../assets/career_panorama/youjianto.png" class="btn-img"/>
                            </div>
                             

                            <!--职业测试和维度分析--->
                            <img src="../../assets/career_panorama/isc-ics.png" class="occupational-test"/>
                            <img src="../../assets/career_panorama/dimension.png" class="dimensional-analysis"/>

                        </div>
                        <div style="display: flex; align-items: flex-end;">
                             <img src="../../assets/career_panorama/occupational-assessment.png" class="tool-img"/>
                        </div>
                     </div>
                </div>
                <!---ai简历优化-->
                <div class="resume-optimization" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-offset="-100">
                    <div class="resume-optimization-box">
                        <div class="resume-optimization-img">
                            <img class="optimization-img" src="../../assets/career_panorama/optimize-ai-img.png"/>
                            <img src="../../assets/career_panorama/improvement-items.png" class="improvement-items"/>
                        </div>
                        <div class="ai-resume-optimization">
                            <div style="height: 60px;"></div>
                            <div class="title">
                                AI简历优化
                            </div>
                             <div style="height: 10px;"></div>
                            <div class="txt">
                                根据用户提供的个人简历及目标岗位，自动抓取核心关键词，建立岗位能力需求模型。对简历进行格式规范性、内容质量、岗位匹配度等多维度评估，运用标准 STAR 法则润色项目经历，使简历描述更具逻辑性和说服力。确保简历内容完整、表述具体且与目标岗位高度契合。
                            </div>
                             <div style="height: 10px;"></div>
                             <div class="tags">
                                <div class="tag">JD关键词抓取</div>
                                <div class="tag">STAR智能润色</div>
                                <div class="tag">结构化评估</div>
                             </div>
                             <div style="height: 35px;"></div>
                             <div style="display: flex; justify-content: flex-end;">
                               <div @click="openPopUp">
                                <experience-now />
                               </div>
                             </div>
                        </div>
                    </div>
                </div>
                <!--ai模拟面试-->
                 <div class="resume-optimization" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-offset="-100">
                    <img class="mock-interview" src="../../assets/career_panorama/mock-interview.png" />
                    <div class="resume-optimization-box" style="width: 1106px; justify-content: space-between;">
                         <div class="ai-resume-optimization">
                            <div style="height: 60px;"></div>
                            <div class="title">
                                AI模拟面试
                            </div>
                             <div style="height: 10px;"></div>
                            <div class="txt">
                                根据用户上传的个人简历及目标岗位，生成定制化试题，精准模拟面试场景。学生作答时可查看答题思路，获取题目考察重点、回答结构等。面试结束后系统生成详细分析报告，从逻辑性、项目成果量化、岗位契合度等方面点评，并提供示例回答，帮助学生优化面试表现。
                            </div>
                             <div style="height: 10px;"></div>
                             <div class="tags">
                                <div class="tag">定制化试题</div>
                                <div class="tag">多场景模拟</div>
                                <div class="tag">智能诊断反馈</div>
                             </div>
                             <div style="height: 35px;"></div>
                            <div @click="openPopUp">
                                <experience-now />
                               </div>
                        </div>

                        <div class="resume-optimization-img" style="width: 349px;">
                            <img class="optimization-img" src="../../assets/career_panorama/mock-interview-xcx.png"/>
                        </div>
                    </div>
                </div>
                <!--求职攻略能力训练--->
                <div class="strategy-guide" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-offset="-100">
                    <div class="strategy-guide-box">
                        <div class="strategy-guide-content">
                            <div style="height: 60px;"></div>
                            <div class="title">求职攻略</div>
                            <div style="height: 10px;"></div>
                            <div class="txt">提供一站式求职指导，涵盖求职流程梳理、笔/面试技巧、求职渠道等内容，帮助学生快速掌握从自我认知到成功入职的关键信息与实用技能，提升求职效率和成功率。</div>
                            <div style="height: 24px;"></div>
                            <div class="tags">
                                <div class="tag">求职全流程</div>
                                <div class="tag">避坑指南</div>
                                <div class="tag">定期更新</div>
                            </div>
                            <div style="height: 62px;"></div>
                            <div class="btn-box">
                               <div @click="openPopUp">
                                <experience-now />
                               </div>
                            </div>
                        </div>
                    </div>
                    <div class="ability-box" data-aos="fade-up" data-aos-anchor-placement="center-bottom">
                         <div class="strategy-guide-content">
                            <div style="height: 60px;"></div>
                            <div class="title">能力训练场</div>
                            <div style="height: 10px;"></div>
                            <div class="txt">
                                针对热门岗位提供企业真实项目脱敏案例试题与各阶段解题思路，提供企业优秀项目文档供学生对照学习，帮助学生逐步掌握项目全流程操作，培养综合职业能力。
                            </div>
                            <div style="height: 24px;"></div>
                            <div class="tags">
                                <div class="tag">行业真题</div>
                                <div class="tag">试题解析</div>
                                <div class="tag">模板文档</div>
                            </div>
                            <div style="height: 62px;"></div>
                            <div class="btn-box">
                                <div @click="openPopUp">
                                <experience-now />
                               </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </div>
     </div>
    <pop-up ref="popUp"/>
    <contact-us/>

  </div>
</template>

<script>
import contactUs from '../../components/ContactUs/contactUs.vue'
import experienceNow from '../../components/ExperienceNow/experienceNow.vue'
import popUp from '../../components/PopUp/popUp.vue'
export default {
  name: 'careerPanorama',
  components:{
    contactUs,
    popUp,
    experienceNow
  },
  mounted() {
    window.scrollTo({
      top: 0,
    })
  },data() {
    return {
      isAuthority: false,
    }
  },
  methods:{
     openPopUp(){
        this.$refs.popUp.open();
     }
  }
}
</script>

<style lang="scss" scoped> 
  .banner-head{
    width: 100%;
     height: 700px;
     background-image: url("../../assets/career_panorama/banner-head.png");
     background-repeat: no-repeat;
     background-size: cover;
     background-position: center;
     display: flex;
     .banner-head-txt{
        width: 1280px;
        text-align: left;
        height: 412px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        .title{
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 60px;
            color: #FF6E00;
            line-height: 66px;
            text-align: left;
            font-style: normal;
        }
        .txt{
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 36px;
            color: #171A1D;
            line-height: 66px;
            text-align: left;
            font-style: normal;
        }
     }
  }
  .career-panorama-content{
    width: 100%;
    height: 1891px;
    background: rgba(246,246,246,0.6);
    box-shadow: inset 0px 1px 3px 0px rgba(255,255,255,0.5);
    position: relative;
    .bg{
        width: 1216px;
        height: 1144px;
        position: absolute;
        right: 0;
        bottom: 255px;
    }
    .content{
        height: 1770px;
        width: 1280px;
        margin: 0 auto;
        display: flex;
        align-items: flex-end;
        .content-box{
            height: 1690px;
            width: 1280px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .evaluation-tool{
                width: 1280px;
                height: 400px;
                background-image: url("../../assets/career_panorama/evaluation-tool-bg.png");
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
                display: flex;
                justify-content: center;
                .evaluation-tool-box{
                    width: 1103px;
                    display: flex;
                    .tool-txt{
                        width: 758px;
                        height: 100%;
                        position: relative;
                        .title{
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 600;
                            font-size: 24px;
                            color: #FFFFFF;
                            line-height: 33px;
                            text-align: left;
                            font-style: normal;
                        }
                        .txt{
                            width: 562px;
                            height: 124px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 500;
                            font-size: 16px;
                            color: #FFFFFF;
                            line-height: 31px;
                            text-align: justify;
                            font-style: normal;
                        }
                        .tags{
                            width: 410px;
                            height: 36px;
                            display: flex;
                            justify-content: space-between;
                            .tag{
                                width: 130px;
                                height: 36px;
                                border-radius: 6px;
                                border: 1px solid #FFFFFF;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FFFFFF;
                                line-height: 36px;
                                text-align: center;
                                font-style: normal;
                            }
                        }

                        .more-btn-no{
                           width: 116px;
                           height: 38px;
                           background: #FF6E00 ;
                           box-shadow: inset 0px 1px 3px 0px rgba(255,255,255,0.5);
                           border-radius: 21px;
                           border: 2px solid #FFFFFF;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                           .btn-txt{
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 500;
                                font-size: 14px;
                                color: #FFFFFF;
                                line-height: 22px;
                                text-align: center;
                                font-style: normal;
                                
                            }
                        }

                        .more-btn{
                            width: 120px;
                            height: 42px;
                            background: #FFFFFF;
                            box-shadow: inset 0px 1px 3px 0px rgba(255,255,255,0.5);
                            border-radius: 21px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                             cursor: pointer;
                            .btn-txt{
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 500;
                                font-size: 14px;
                                color: #FF6E00;
                                line-height: 22px;
                                text-align: center;
                                font-style: normal;
                                
                            }
                            .btn-img{
                                width: 14px;
                                height: 12px;
                            }
                        }

                        .occupational-test{
                            width: 146px;
                            height: 82px;
                            position: absolute;
                            right: -14px;
                            top: 101px;
                            transition: transform 0.2s ease-in-out;
                        }
                        .occupational-test:hover{
                            transform: scale(1.06); /* 元素放大到110% */
                        }
                        .dimensional-analysis{
                            transition: transform 0.2s ease-in-out;
                            width: 260px;
                            height: 116px;
                            position: absolute;
                            right: -20px;
                            bottom: 47px;
                        }
                        .dimensional-analysis:hover{
                            transform: scale(1.06); /* 元素放大到110% */
                        }
                    }
                    .tool-img:hover{
                       
                        transform: scale(1.03);
                    }
                    .tool-img{
                        width: 345px;
                        height: 368px;
                         transition: transform 0.2s ease-in-out;
                    }
                }
            }

            .resume-optimization{
                width: 1280px;
                height: 400px;
                background: linear-gradient( 180deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.5) 100%);
                border-radius: 16px;
                backdrop-filter: blur(10px);
                display: flex;
                justify-content: center;
                position: relative;
                .mock-interview{
                    transition: transform 0.2s ease-in-out;
                    width: 521px; 
                    height: 216px;
                    position: absolute; 
                    bottom: 68px; 
                    right: 27px;
                    z-index: 9;
                }
                .mock-interview:hover{
                    transform: scale(1.06); /* 元素放大到110% */
                }
                .resume-optimization-box{
                    display: flex;
                }
                .resume-optimization-img{
                    width: 544px;
                    height: 100%;
                    text-align: left;
                    display: flex;
                    align-items: flex-end;
                    position: relative;
                    .optimization-img{
                        width: 349px;
                        height: 367px;
                        transition: transform 0.2s ease-in-out;
                    }
                    .optimization-img:hover{
                        transform: scale(1.06); /* 元素放大到110% */
                    }
                    .improvement-items{
                        position: absolute;
                        width: 384px;
                        height: 244px;
                        right: 0;
                        bottom: 35px;
                        transition: transform 0.2s ease-in-out;
                    }
                    .improvement-items:hover{
                        transform: scale(1.06); /* 元素放大到110% */
                    }
                }
                .ai-resume-optimization{
                    width: 563px;
                    height: 100%;
                    .tags{
                        width: 410px;
                        height: 36px;
                        display: flex;
                        justify-content: space-between;
                        .tag{
                            width: 130px;
                            height: 36px;
                            border-radius: 6px;
                            border: 1px solid #FF6E00;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FF6E00;
                            line-height: 36px;
                            text-align: center;
                            font-style: normal;
                        }
                    }
                    .title{
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        font-size: 24px;
                        color: #171A1D;
                        line-height: 33px;
                        text-align: left;
                        font-style: normal;
                    }
                    .txt{
                        width: 563px;
                        height: 124px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: rgba(23,26,29,0.6);
                        line-height: 31px;
                        text-align: justify;
                        font-style: normal;
                    }
                    .more-btn{
                        width: 120px;
                        height: 42px;
                        background: linear-gradient( 228deg, #FF6503 0%, #FF8012 100%);
                        box-shadow: inset 0px 1px 3px 0px rgba(255,255,255,0.5);
                        border-radius: 21px;
                        display:flex;
                        align-items: center;
                        justify-content: center;
                         cursor: pointer;
                        .btn-txt{
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 500;
                            font-size: 14px;
                            color: #FFFFFF;
                            line-height: 22px;
                            text-align: center;
                            font-style: normal;
                            align-items: center;
                            justify-content: center;
                            
                        }
                    }
                }
            }
            .strategy-guide{
                width: 1280px;
                height: 400px;
                display: flex;
                justify-content: space-between;
                .strategy-guide-box,.ability-box{
                    width: 629px;
                    height: 400px;
                    background: linear-gradient( 180deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.5) 100%);
                    border-radius: 16px;
                    backdrop-filter: blur(10px);
                    display: flex;
                    justify-content: center;


                    .strategy-guide-content{
                        width: 453px;
                        text-align: left;
                        .title{
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 600;
                            font-size: 24px;
                            color: #171A1D;
                            line-height: 33px;
                            text-align: left;
                            font-style: normal;
                        }
                        .txt{
                            width: 453px;
                            height: 93px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 16px;
                            color: rgba(23,26,29,0.6);
                            line-height: 31px;
                            text-align: justify;
                            font-style: normal;
                        }

                        .btn-box{
                            display: flex;
                            justify-content: flex-end;
                            .btn{
                                width: 120px;
                                height: 42px;
                                background: linear-gradient( 233deg, #FF6503 0%, #FF8012 100%);
                                box-shadow: inset 0px 1px 3px 0px rgba(255,255,255,0.5);
                                border-radius: 21px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                 cursor: pointer;
                                .btn-txt{
                                    font-family: PingFangSC, PingFang SC;
                                    font-weight: 500;
                                    font-size: 14px;
                                    color: #FFFFFF;
                                    line-height: 22px;
                                    text-align: center;
                                    font-style: normal;
                                    
                                }
                                .btn-img{
                                    width: 14px;
                                    height: 12px;
                                }
                            }
                        }

                        .tags{
                            width: 416px;
                            height: 36px;
                            display: flex;
                            justify-content: space-between;
                            .tag{
                                width: 132px;
                                height: 36px;
                                border-radius: 6px;
                                border: 1px solid #FF6E00;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FF6E00;
                                line-height: 36px;
                                text-align: center;
                                font-style: normal;
                            }
                        }
                    }
                }
            }
        }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/career_panorama/index.vue